import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	undoneLine: {
		display: 'block',
		marginTop: THEME.spacing.xs,
	},
	warningBanner: {
		backgroundColor: THEME.colors.warning.light,
		border: `1px solid ${THEME.colors.warning.main}`,
		borderRadius: THEME.common.borderRadius,
		color: THEME.colors.text.main,
		padding: THEME.spacing.md,
		fontSize: THEME.typography.fontSizes.sm,
		lineHeight: 1.5,
	},
});
